.search {
  display: flex;
  padding: 8px 0 8px 16px;
  width: 100%;

  [data-input-wrapper] {
    border: none;
    padding-left: 0;
    width: 100%;
  }

  [data-input-wrapper] > span:last-child {
    cursor: pointer;

    svg {
      fill: var(--icon-soft);
    }
  }
}
